<template>
    <b-row>
        <b-col>
            <b-row class="py-3">
                <b-col>
                    <h1>Auftragsliste</h1>
                </b-col>
            </b-row>
            <b-row class="py-3">
                <b-col>
                    <auftragstabelle ref="auftragstabelle" />
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
  import Auftragstabelle from '../common/Auftragstabelle'

  export default {
    name: 'PageAuftragsliste',
    components: {Auftragstabelle},
    metaInfo() {
      return {
          title: 'Auftragsliste'
      }
    },
  }
</script>

<style scoped>
</style>
